export default __webpack_public_path__ + "static/media/automovelAutoValor.bee068d3.png";